var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[(_vm.valorImagen === false)?_c('div',{staticClass:"d-flex flex-column justify-space-between align-center"},[_c('v-img',{attrs:{"src":_vm.imgLogo,"max-width":"320"}})],1):_vm._e(),_c('router-view'),_c('dashboard-core-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }